import React, { Component } from 'react';
import { Table, Button, Form, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import html2canvas from 'html2canvas';
// import ReactDOM from 'react-dom';

import './App.css';

class App extends Component {

  constructor(props) {
    super(props);
    this.RefCopy = React.createRef();
    this.RefHeight = React.createRef();
    this.state = {
      lineHeight: "225px",
      value: '',
      indexCompany: 0,
      isCell: true,
      isCopy: false,
      copied: false,
      defaultValue: {
        cht: "王小明",
        eng: "Tom Wang",
        ext: "",
        ext1: "",
        cell: "0900-000-000",
        section_cht: "管理部資訊課",
        section_eng: "",
        job_cht: "工程師",
        job_eng: "",
        email: "tompu@shinfox.com.tw",
      },
      company: [
        
        {
          selectOption: "森崴能源股份有限公司",
          cht: "森崴能源股份有限公司",
          eng: "SHINFOX ENERGY CO., LTD.",
          logo: "logo.png",
          logoW: "180",
          color: "#182388",
          color: "#182388",
          addr: "236040 新北市土城區中央路四段49號",
          web: "www.shinfox.com.tw",
          tel: "02-2269-9888",
          fax: "02-2269-9815",
          free: "免付費電話 0800-667-667"
        },
        {
          selectOption: "森崴能源股份有限公司(南辦)",
          cht: "森崴能源股份有限公司",
          eng: "SHINFOX ENERGY CO., LTD.",
          logo: "logo.png",
          logoW: "180",
          color: "#182388",
          addr: "71149 台南市歸仁區民生六街27號",
          web: "www.shinfox.com.tw",
          tel: "06-239-3399",
          fax: "06-239-2345",
          free: "免付費電話 0800-667-667"
        },
        {
          selectOption: "富崴能源股份有限公司",
          cht: "富崴能源股份有限公司",
          eng: "Foxwell Energy Corporation Ltd.",
          logo: "logo.png",
          logoW: "180",
          color: "#f4981c",
          addr: "236040 新北市土城區中央路四段49號",
          web: "www.shinfox.com.tw",
          tel: "02-2269-9888",
          fax: "02-2269-9815",
          free: "免付費電話 0800-667-667"
        },
        {
          selectOption: "彰苑風力發電股份有限公司",
          cht: "彰苑風力發電股份有限公司",
          eng: "Changyuan Wind Power Ltd.",
          logo: "logo.png",
          logoW: "180",
          color: "#0098c7",
          addr: "236040 新北市土城區中央路四段49號",
          web: "www.shinfox.com.tw",
          tel: "02-2269-9888",
          fax: "02-2269-9815",
          free: "免付費電話 0800-667-667"
        },
        {
          selectOption: "北苑風力發電股份有限公司",
          cht: "北苑風力發電股份有限公司",
          eng: "Beiyuan Wind Power Ltd.",
          logo: "logo.png",
          logoW: "180",
          color: "#0098c7",
          addr: "236040 新北市土城區中央路四段49號",
          web: "www.shinfox.com.tw",
          tel: "02-2269-9888",
          fax: "02-2269-9815",
          free: "免付費電話 0800-667-667"
        },
        {
          selectOption: "世豐電力股份有限公司",
          cht: "世豐電力股份有限公司",
          eng: "Shih Fong Power Co., Ltd.",
          logo: "logo_shihfong.png",
          logoW: "50",
          color: "#00ae98",
          web: "www.shinfox.com.tw",
          addr: "236040 新北市土城區中央路四段49號",
          tel: "02-2269-9888",
          fax: "02-2269-9815",
          addr1: "981003 花蓮縣玉里鎮城中五街107號",
          tel1: "03-884-1599",
          free: "免付費電話 0800-667-667"
        },
        {
          selectOption: "欣鑫天然氣股份有限公司",
          cht: "欣鑫天然氣股份有限公司",
          eng: "Shinfox Natural Gas Co., Ltd.",
          logo: "logo_naturalgas.png",
          logoW: "240",
          color: "#ea4f13",
          addr: "236040 新北市土城區中央路四段49號",
          web: "www.shinfox.com.tw",
          tel: "02-2269-9888",
          fax: "02-2269-9815",
          free: "免付費電話 0800-667-667"
        },
        {
          selectOption: "九崴電力股份有限公司",
          cht: "九崴電力股份有限公司",
          eng: "Fox Power Corporation",
          logo: "logo_foxpower.png",
          logoW: "240",
          color: "#66777c",
          addr: "236040 新北市土城區中央路四段49號",
          web: "www.shinfox.com.tw",
          tel: "02-2269-9888",
          fax: "02-2269-9815",
          free: "免付費電話 0800-667-667"
        },
        {
          selectOption: "富威電力股份有限公司", 
          cht: "富威電力股份有限公司",
          eng: "Foxwell Power Co., Ltd.",
          logo: "logo.png",
          logoW: "180",
          color: "#182388",
          addr: "236040 新北市土城區中央路四段49號",
          web: "platform.fwp.com.tw",
          tel: "02-2269-9888",
          fax: "02-2269-9815",
          free: "免付費電話 0800-667-667"
        },
        {
          selectOption: "衆崴能源股份有限公司",
          cht: "衆崴能源股份有限公司",
          eng: "SYNERGY CO., LTD.",
          logo: "logo_synergy2.png",
          logoW: "180",
          color: "#8ead1b",
          // color: "#aace20",
          addr: "236040 新北市土城區中央路四段49號",
          web: "www.syn.com.tw",
          tel: "02-2269-9888",
          fax: "02-8192-6118",
          free: ""
        },
        {
          selectOption: "昆山九崴信息科技有限公司",
          cht: "昆山九崴信息科技有限公司",
          eng: "Kunshan Jiuwei Info Tech Co., Ltd.",
          logo: "logo.png",
          logoW: "180",
          color: "#182388",
          addr: "江苏省昆山市前进东路399号台协大厦704",
          web: "www.shinfox.com.tw",
          tel: "0512-55215075",
          fax: "0512-36859828",
        },
        {
          selectOption: "元杉森林自然資源股份有限公司",
          cht: "元杉森林自然資源股份有限公司",
          eng: "Fox Forest Natural Resources Co., Ltd.",
          logo: "foxforest1.png",
          logoW: "240",
          color: "#294951",
          addr: "236040 新北市土城區中央路四段49號",
          web: "www.shinfox.com.tw",
          tel: "02-2269-9888",
          fax: "02-2269-9815",
        }

        
      ]
    }
  }
  componentDidMount() {
    let defaultValue = localStorage.getItem("defaultValue");
    let defaultCompany = localStorage.getItem("defaultCompany");


    if (defaultValue && defaultCompany) {
      if (defaultValue.length > 2) {
        this.setState({
          defaultValue: JSON.parse(defaultValue),
          indexCompany: JSON.parse(defaultCompany)
        });
        setTimeout(()=>{this.setHeight()},100);
        setTimeout(()=>{this.setHeight()},1200);
        setTimeout(()=>{this.setHeight()},2500);
        setTimeout(()=>{this.setHeight()},5000);
      }
    }
    if (window.location.search.split("?")[1] === "shihfong") {
        this.setState({indexCompany: 5});
        setTimeout(()=>{this.setHeight()},100);
        setTimeout(()=>{this.setHeight()},1200);
        setTimeout(()=>{this.setHeight()},2500);
        setTimeout(()=>{this.setHeight()},5000);
    }
    setTimeout(()=>{this.setHeight()},100);
    setTimeout(()=>{this.setHeight()},1200);
    setTimeout(()=>{this.setHeight()},2500);
    setTimeout(()=>{this.setHeight()},5000);
  }
  componentDidUpdate() {
    this.save()
  }

  // saveimg = () => {
  //   html2canvas(document.querySelector("#capture")).then(canvas => {
  //     document.body.appendChild(canvas)
  //   });
  // }

  exportImg = () => {
    html2canvas(document.querySelector("#capture"), { // 转换为图片
        useCORS: true // 解决资源跨域问题
    }).then(canvas => {
        // imgUrl 是图片的 base64格式 代码 png 格式
        let imgUrl = canvas.toDataURL("image/png");
        //下面是 下载图片的功能。 不需要不加 注意加 .png
        this.downloadIamge(imgUrl, "signature.png")})
}


  downloadIamge(imgsrc, name) {
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
          let a = document.createElement("a"); // 生成一个a元素
          let event = new MouseEvent("click"); // 创建一个单击事件
          a.download = name || "photo"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
  }

  save = () => {
    localStorage.setItem("defaultValue", JSON.stringify(this.state.defaultValue));
    localStorage.setItem("defaultCompany", JSON.stringify(this.state.indexCompany));
  }

  setHeight = () => {
    var height = this.RefHeight.current.clientHeight;
    this.setState({ lineHeight: height - 3 });
    console.log("height:", height);
  }

  copyEvent = () => {
    var str = this.RefCopy.current;
    if (str) {
      window.getSelection().selectAllChildren(str);
      document.execCommand("Copy");
      this.setState({ isCopy: true });
    }
  }

  render() {
    const { isCell, isCopy, defaultValue, company, indexCompany } = this.state;
    const style = {
      line: {
        width: "3px",
        height: this.state.lineHeight
      },
      company_cht: {
        fontFamily: "微軟正黑體",
        color: this.state.company[this.state.indexCompany].color,
        fontSize: "14px",
        fontWeight: "bold",
        height: "17px"
      },
      company_eng: {
        fontFamily: "微軟正黑體",
        color: this.state.company[this.state.indexCompany].color,
        fontSize: "12px",
        lineHeight: "14px",
        height: "18px",
        fontWeight: "normal",
      },
      company_synergy_cht: {
        fontFamily: "微軟正黑體",
        color: this.state.company[this.state.indexCompany].color,
        fontSize: "15px",
        lineHeight: "14px",
        height: "18px",
        fontWeight: "bold",
      },
      synergy_slogan: {
        fontFamily: "微軟正黑體",
        color: this.state.company[this.state.indexCompany].color,
        fontSize: "13px",
        lineHeight: "28px",
        height: "28px",
        fontWeight: "bold",
      },
      company_synergy_eng: {
        fontFamily: "微軟正黑體",
        color: this.state.company[this.state.indexCompany].color,
        fontSize: "12px",
        lineHeight: "14px",
        height: "18px",
        fontWeight: "bold",
      },
    }
    return (
      <div className="App">
        <div >
          <Container>
            <Row>
              <div className="col-md-12" style={{ display: "flex", alignItems: "flex-end" }}>
                <div >
                  <h1 style={{ padding: "15px 0 0", color: "#1b2387", fontSize: "24px" }}>
                    <span style={{ fontWeight: "normal", color: "#333" }}>森崴能源電子郵件簽名檔產生器</span>
                  </h1>
                  <p style={{ color: "#555", margin: 0 }}>請輸入 1.簽名檔基本資料基本資料，並於 2.預覽正確無誤後，點選「3.複製簽名檔」按鈕，貼至 Gmail / 設定 / 簽名，即可設定簽名檔。</p>
                </div>
              </div>

            </Row>
          </Container>
          <hr />
        </div>
        <Row style={{ margin: 0 }} >
          <div className="col-md-6" onClick={e => this.setState({ isCopy: false })}>
            <Container>
              <Row>

                <Form className="col-md-12">
                  <h2 style={{ fontSize: "20px" }}>1. 輸入簽名檔基本資料</h2>
                  <hr />
                  <Form.Row>
                    <Form.Group as={Col} md={6} controlId="formGridCompany">
                      <Form.Label><b>請先選擇公司</b></Form.Label>
                      <Form.Control
                        as="select"
                        defaultValue={company[indexCompany].cht}
                        value={company[indexCompany].cht}
                        onChange={(e) => {
                          this.setState({ indexCompany: e.target.selectedIndex });
                          setTimeout( ()=> {
                            this.setHeight();
                          },500)
                        
                        }}>
                        {company.map(
                          (item, i) => <option key={i} index={i}>{item.selectOption}</option>
                        )}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group as={Col} md={6} controlId="formGridEmail">
                      <Form.Label>公司英文名稱：</Form.Label>
                      <Form.Control
                        type="name_cht"
                        placeholder="--"
                        value={company[indexCompany].eng}
                        className="disable"
                        onChange={e => alert("公司名稱不能修改")} />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} md={6} controlId="formGridNameCht">
                      <Form.Label><span className="colorR">*</span> 姓名（中文）：</Form.Label>
                      <Form.Control
                        type="name_eng"
                        placeholder="--"
                        value={this.state.defaultValue.cht}
                        onChange={e => {
                          let val = e.target.value;
                          this.setState(prevState => ({
                            defaultValue: {
                              ...prevState.defaultValue,
                              cht: val
                            }
                          }))
                        }} />
                    </Form.Group>

                    <Form.Group as={Col} md={6} controlId="formGridNameEng">
                      <Form.Label><span className="colorR">*</span> 姓名（英文）：</Form.Label>
                      <Form.Control
                        type="name_eng"
                        placeholder="--"
                        value={this.state.defaultValue.eng}
                        onChange={e => {
                          let val = e.target.value;
                          this.setState(prevState => ({
                            defaultValue: {
                              ...prevState.defaultValue,
                              eng: val
                            }
                          }))
                        }} />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} controlId="formGridPassword">
                      <Form.Label><span className="colorR">*</span> 部門（中文）：</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="--"
                        value={this.state.defaultValue.section_cht}
                        onChange={e => {
                          let val = e.target.value;
                          this.setState(prevState => ({
                            defaultValue: {
                              ...prevState.defaultValue,
                              section_cht: val
                            }
                          }));
                          setTimeout(()=>{this.setHeight()},500);
                        }} />
                    </Form.Group>
                    <Form.Group as={Col} controlId="formGridPassword">
                      <Form.Label><span className="colorR"></span> 部門（英文）：</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="--"
                        value={this.state.defaultValue.section_eng}
                        onChange={e => {
                          let val = e.target.value;
                          this.setState(prevState => ({
                            defaultValue: {
                              ...prevState.defaultValue,
                              section_eng: val
                            }
                          }));
                          setTimeout(()=>{this.setHeight()},500);
                        }} />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} md={6} controlId="formGridPassword">
                      <Form.Label> <span className="colorR">*</span> 職稱（中文）：</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="--"
                        value={this.state.defaultValue.job_cht}
                        onChange={e => {
                          let val = e.target.value;
                          this.setState(prevState => ({
                            defaultValue: {
                              ...prevState.defaultValue,
                              job_cht: val
                            }
                          }));
                          setTimeout(()=>{this.setHeight()},500);
                        }} />
                    </Form.Group>
                    
                    <Form.Group as={Col} md={6} controlId="formGridPassword">
                      <Form.Label> 職稱（英文）：</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="--"
                        value={this.state.defaultValue.job_eng}
                        onChange={e => {
                          let val = e.target.value;
                          this.setState(prevState => ({
                            defaultValue: {
                              ...prevState.defaultValue,
                              job_eng: val
                            }
                          }));
                          setTimeout(()=>{this.setHeight()},500);
                        }} />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} controlId="formGridAddr">
                      <Form.Label>公司地址：</Form.Label>
                      <Form.Control
                        type="addr"
                        placeholder="--"
                        value={company[indexCompany].addr}
                        className="disable"
                        onChange={e => alert("公司地址不能修改")} />
                    </Form.Group>
                  </Form.Row>

                  {company[indexCompany].addr1 ?
                    <Form.Row>
                      <Form.Group as={Col} controlId="formGridAddr">
                        <Form.Label>公司地址1：</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="--"
                          value={company[indexCompany].addr1}
                          className="disable"
                          onChange={e => alert("公司地址不能修改")} />
                      </Form.Group>
                    </Form.Row> : <></>}

                  <Form.Row>
                    <Form.Group as={Col} md={6} controlId="formGridWeb">
                      <Form.Label>公司網址：</Form.Label>
                      <Form.Control
                        type="addr"
                        placeholder="--"
                        value={company[indexCompany].web}
                        className="disable"
                        onChange={e => alert("公司網站網址不能修改")}
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={6} controlId="formGridWeb">
                      <Form.Label><span className="colorR">*</span> 信箱：</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="--"
                        value={this.state.defaultValue.email}
                        onChange={e => {
                          let val = e.target.value;
                          this.setState(prevState => ({
                            defaultValue: {
                              ...prevState.defaultValue,
                              email: val
                            }
                          }))
                        }} />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} md={6} controlId="formGridTel">
                      <Form.Label>電話：</Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder="--"
                        value={company[indexCompany].tel}
                        className="disable"
                        onChange={e => alert("公司電話不能修改")} />
                    </Form.Group>

                    <Form.Group as={Col} md={6} controlId="formGridExt">
                      <Form.Label><span className="colorR">*</span> 分機：</Form.Label>
                      <Form.Control
                        type="ext"
                        placeholder="--"
                        value={this.state.defaultValue.ext}
                        onChange={e => {
                          let val = e.target.value;
                          this.setState(prevState => ({
                            defaultValue: {
                              ...prevState.defaultValue,
                              ext: val
                            }
                          }))
                        }} />
                    </Form.Group>
                  </Form.Row>

                  {company[indexCompany].tel1 ?
                    <Form.Row>
                      <Form.Group as={Col} md={6} controlId="formGridTel">
                        <Form.Label>電話1：</Form.Label>
                        <Form.Control
                          type="tel"
                          placeholder="--"
                          value={company[indexCompany].tel1}
                          className="disable"
                          onChange={e => alert("公司電話不能修改")} />
                      </Form.Group>
                      <Form.Group as={Col} md={6} controlId="formGridExt">
                        <Form.Label><span className="colorR">*</span> 分機：</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="--"
                          value={this.state.defaultValue.ext1}
                          onChange={e => {
                            let val = e.target.value;
                            this.setState(prevState => ({
                              defaultValue: {
                                ...prevState.defaultValue,
                                ext1: val
                              }
                            }))
                          }} />
                      </Form.Group>
                    </Form.Row> : <></>}
                  <Form.Row>
                    <Form.Group as={Col} md={6} controlId="formGridFax">
                      <Form.Label>傳真：</Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder="--"
                        value={company[indexCompany].fax}
                        className="disable"
                        onChange={e => alert("公司傳真不能修改")} />
                    </Form.Group>

                    <Form.Group as={Col} md={6} controlId="formGridCell">
                      <Form.Label>是否提供手機：
                        <Form.Check
                          checked={isCell}
                          inline
                          type="radio"
                          label="是"
                          name="formHorizontalRadios"
                          id="formHorizontalRadios1"
                          onChange={e => {
                            this.setState({ isCell: true })
                            setTimeout(()=>{this.setHeight()},500);
                          }}
                        />
                        <Form.Check
                          checked={!isCell}
                          inline
                          type="radio"
                          label="否"
                          name="formHorizontalRadios"
                          id="formHorizontalRadios2"
                          onChange={e => {
                            this.setState({ isCell: false })
                            setTimeout(()=>{this.setHeight()},500);
                          }}
                        />
                      </Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder="--"
                        value={this.state.defaultValue.cell}
                        onChange={e => {
                          let val = e.target.value;
                          this.setState(prevState => ({
                            defaultValue: {
                              ...prevState.defaultValue,
                              cell: val
                            }
                          }))
                        }} />
                    </Form.Group>
                  </Form.Row>
                  {company[indexCompany].fax1 ?
                    <Form.Row>
                      <Form.Group as={Col} md={6} controlId="formGridFax">
                        <Form.Label>傳真1：</Form.Label>
                        <Form.Control
                          type="tel"
                          placeholder="--"
                          value={company[indexCompany].fax1}
                          className="disable"
                          onChange={e => alert("公司傳真不能修改")} />
                      </Form.Group>
                    </Form.Row> : <></>}
                </Form>
              </Row>
            </Container>
          </div>

          <div className="col-md-6 right_box" >
            <Container>
              <Row>
                <div className="col-md-12" style={{ margin: "0 auto", display: "inline-block" }}>
                  <h2 style={{ fontSize: "20px" }}>2. 簽名檔預覽</h2>
                  <hr />
                  <div ref={this.RefCopy}>
                    <Table id="capture" style={{ maxWidth: "100%", textAlign: "left" }}>
                      <tbody>
                        <tr>
                          {company[indexCompany].cht !== "眾意能源股份有限公司" && company[indexCompany].cht !== "元杉森林自然資源股份有限公司" ? 
                            <><td style={{ width: "5px", textAlign: "center" }}>
                                <img src="https://tools.shinfox.com.tw/rectangleline1.png?1" alt="logo" style={style.line} />
                              </td>
                              <td style={{ width: "8px" }}></td></>
                             : <></>
                          }
                          
                          <td>
                            <div ref={this.RefHeight}> {
                                company[indexCompany].cht !== "世豐電力股份有限公司" ? <>
                                    <img width={company[indexCompany].logoW} src={"https://tools.shinfox.com.tw/"+company[indexCompany].logo} alt="logo"  style={{ paddingBottom: "5px" }} />
                                    <div style={style.company_cht}>
                                      {company[indexCompany].cht}
                                    </div>
                                    <div style={style.company_eng}>
                                      {company[indexCompany].eng}
                                    </div> 
                                  </>: <></>
                              }

                              {
                                company[indexCompany].cht === "世豐電力股份有限公司" ? 
                                <>
                                    <Table style={{ borderCollapse: "collapse" }}>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <img width={company[indexCompany].logoW} src={"https://tools.shinfox.com.tw/"+company[indexCompany].logo}  alt="logo" style={{ width: "40px", paddingBottom: "5px" , paddingRight: "3px"}} /> 
                                          </td>
                                          <td>
                                            <div style={style.company_cht}>
                                              {company[indexCompany].cht}
                                            </div>
                                            
                                            <div style={style.company_eng}>
                                              {company[indexCompany].eng}
                                            </div> 
                                            
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </>:<></>
                              }
                                                        
                              <div style={{  height: "19px", fontFamily: "微軟正黑體", color: "#000", fontSize: "16px" }}>
                                <span style={{ display: "inline-block" }}>{defaultValue.cht} </span>
                                <span style={{ display: "inline-block", verticalAlign: "text-top", fontSize: "13px" }}> &nbsp; {defaultValue.eng}</span>
                              </div>

                              {defaultValue.section_cht || defaultValue.job_cht ? 
                                <div style={{ fontFamily: "微軟正黑體", color: "#333", fontSize: "12px", height: "14px" }}>{defaultValue.section_cht} {defaultValue.job_cht} </div> :<></> }
                              
                              { defaultValue.job_eng || defaultValue.section_eng ? 
                                <div style={{ fontFamily: "微軟正黑體", color: "#333", fontSize: "12px", height: "16px" }}>
                                  {defaultValue.job_eng}
                                  {defaultValue.job_eng && defaultValue.section_eng ? ", " : ""}
                                  {defaultValue.section_eng}</div> : <></>}
                              <Table>
                                <tbody>
                                  <tr>
                                    <td>
                                      <div style={{ height: "17px" }}>
                                        <Table style={{ borderCollapse: "collapse" }}>
                                          <tbody>
                                            <tr>
                                              <td><img width="13" src="https://tools.shinfox.com.tw/icon_mail01.png"  alt="地址"  style={{ width: "13px" }} /></td>
                                              <td style={{ width: "5px" }}></td>
                                              <td style={{ fontSize: "12px", fontFamily: "微軟正黑體" }}>{company[indexCompany].addr}</td>
                                            </tr>
                                          </tbody>

                                        </Table>
                                      </div>
                                      <div style={{ height: "17px" }}>
                                        <Table style={{ borderCollapse: "collapse" }}>
                                          <tbody>
                                            <tr>
                                              <td><img width="13"  src="https://tools.shinfox.com.tw/icon_mail02.png" alt="電話"  style={{ width: "13px" }} /></td>
                                              <td style={{ width: "5px" }}></td>
                                              <td style={{ fontSize: "12px" }}> {company[indexCompany].tel} {this.state.defaultValue.ext ? "#" : ""}{defaultValue.ext}</td>
                                            </tr>
                                          </tbody>
                                        </Table>
                                      </div>
                                      <div style={{ height: "17px" }}>
                                        <Table style={{ borderCollapse: "collapse" }}>
                                          <tbody>
                                            <tr>
                                              <td><img  width="13" src="https://tools.shinfox.com.tw/icon_mail03.png" alt="傳真"  style={{ width: "13px" }} /></td>
                                              <td style={{ width: "5px" }}></td>
                                              <td style={{ fontSize: "12px" }}> {company[indexCompany].fax}</td>
                                            </tr>
                                          </tbody>
                                        </Table>
                                      </div>

                                      {company[indexCompany].addr1 ?
                                        <div style={{ height: "17px" }}>
                                          <Table style={{ borderCollapse: "collapse" }}>
                                            <tbody>
                                              <tr>
                                                <td><img width="13"  src="https://tools.shinfox.com.tw/icon_mail01.png" alt="地址"  style={{ width: "13px" }} /></td>
                                                <td style={{ width: "5px" }}></td>
                                                <td style={{ fontSize: "12px", fontFamily: "微軟正黑體" }}>{company[indexCompany].addr1}</td>
                                              </tr>
                                            </tbody>

                                          </Table>
                                        </div> : <></>}

                                      {company[indexCompany].tel1 ?
                                        <div style={{ height: "17px" }}>
                                          <Table style={{ borderCollapse: "collapse" }}>
                                            <tbody>
                                              <tr>
                                                <td><img width="13"  src="https://tools.shinfox.com.tw/icon_mail02.png"  alt="電話"  style={{ width: "13px" }} /></td>
                                                <td style={{ width: "5px" }}></td>
                                                <td style={{ fontSize: "12px" }}> {company[indexCompany].tel1} {this.state.defaultValue.ext1 ? "#" : ""}{defaultValue.ext1}</td>
                                              </tr>
                                            </tbody>

                                          </Table>
                                        </div> : <></>}

                                      {company[indexCompany].fax1 ?
                                        <div style={{ height: "17px" }}>
                                          <Table style={{ borderCollapse: "collapse" }}>
                                            <tbody>
                                              <tr>
                                                <td><img width="13"  src="https://tools.shinfox.com.tw/icon_mail03.png" alt="傳真"  style={{ width: "13px" }}  /></td>
                                                <td style={{ width: "5px" }}></td>
                                                <td style={{ fontSize: "12px" }}> {company[indexCompany].fax1}</td>
                                              </tr>
                                            </tbody>
                                          </Table>
                                        </div> : <></>}


                                      {isCell ?
                                        <div style={{ height: "17px" }}>
                                          <Table style={{ borderCollapse: "collapse" }}>
                                            <tbody>
                                              <tr>
                                                <td><img width="13"  src="https://tools.shinfox.com.tw/icon_mail06.png" alt="手機"  style={{ width: "13px" }}  /></td>
                                                <td style={{ width: "5px" }}></td>
                                                <td style={{ fontSize: "12px" }}> {defaultValue.cell}</td>
                                              </tr>
                                            </tbody>
                                          </Table>
                                        </div> : <></>
                                      }
                                      
                                      <div style={{ height: "17px" }}>
                                        <Table style={{ borderCollapse: "collapse" }}>
                                          <tbody>
                                            <tr>
                                              <td><img width="13" src="https://tools.shinfox.com.tw/icon_mail05.png" alt="mail"  style={{ width: "13px" }}  /></td>
                                              <td style={{ width: "5px" }}></td>
                                              <td style={{ fontSize: "12px" }}><a href={"mailto:" + defaultValue.email} >{defaultValue.email}</a></td>
                                            </tr>
                                          </tbody>
                                        </Table>
                                      </div>
                                      
                                      <div style={{ height: "17px" }}>
                                        <Table style={{ borderCollapse: "collapse" }}>
                                          <tbody>
                                            <tr>
                                              <td><img width="13" src="https://tools.shinfox.com.tw/icon_mail04.png" alt="網站"  style={{ width: "13px" }}  /></td>
                                              <td style={{ width: "5px" }}></td>
                                              <td style={{ fontSize: "12px" }}> <a href={"http://" + company[indexCompany].web} >{company[indexCompany].web}</a> </td>
                                            </tr>
                                          </tbody>
                                        </Table>
                                      </div>

                                      {company[indexCompany].free ?
                                        <div style={{ fontSize: "12px", fontFamily: "微軟正黑體", paddingTop: "3px" }}>
                                          {company[indexCompany].free}
                                        </div> : <></>}

                                        {
                                          company[indexCompany].cht === "眾意能源股份有限公司" ? 
                                          <>
                                              <div style={style.synergy_slogan}>
                                             <span>綠色</span>Energy <span>永續</span>Synergy
                                              </div>
                                          </>:<></>
                                        }

                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </Table>

                  </div>
                  <div>
                    <hr />

                    <div className="col-md-12" style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", marginTop: "20px" }}>
                      <div>
                        <Button
                          variant="success"
                          size="lg"
                          type="button"
                          onClick={() => this.copyEvent()}>3. 複製簽名檔</Button>
                        {isCopy ? <div style={{ color: "red", textAlign: "center" }}> 簽名檔已複製</div> : <></>}

                      </div>
                      <div
                        style={{marginLeft: "15px", color:"blue", cursor:"pointer", marginTop:"15px", textAlign:"center"}}
                        onClick={() => this.exportImg()}>圖檔下載</div>
                    </div>
                    
                  </div>

                </div>

              </Row>
            </Container>


          </div>
        </Row>


      </div>
    );
  }
}

export default App;
